const FRESH_CONFIRMATION_PATTERN =
  /(agree|agreement|consent|waiver|rules?|donat(e|ion)|terms?|liability|signature)/i

export function requiresFreshApplicationConfirmation(key: string): boolean {
  return FRESH_CONFIRMATION_PATTERN.test(key.trim())
}

export function formatApplicationQuestionKey(key: string): string {
  return key
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase())
}
